// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomEmail_wrapper__tZjlv","row":"CustomEmail_row__YhNJM","item":"CustomEmail_item__7It3R"};